module.exports = __webpack_public_path__ + "static/qr-code-bfea40a1a7a83f770736fd4945990ea2.png";